<ng-container *transloco="let t">
    <div
        *ngIf="{
            maskSettings: maskSettings$ | async,
            interval: isInterval.valueChanges | async,
            status: formGroup.statusChanges | async
        } as data"
        [formGroup]="formGroup"
        class="bazis-control bazis-datetime-control"
    >
        <bazis-grid>
            <bazis-row>
                <bazis-col
                    [sizeSm]="!isInterval.value || !isInterval.value.length ? 12 : 6"
                    sizeXs="12"
                    [class.bh-no-padding] = "!isInterval.value || !isInterval.value.length"
                    class="bazis-input-time"
                >
                    <bazis-input-default
                        #timeFromCalendarToggler
                        [titleKey]="isInterval.value.length === 1 ? titleKeyFrom : titleKey"
                        [tooltipKey]="tooltipKey"
                        [tooltipSettings]="tooltipSettings"
                        [noteKey]="noteKey"
                        [titleParams]="titleParams"
                        [tooltipParams]="tooltipParams"
                        [noteParams]="noteParams"
                        formControlName="from"
                        [required$]="requiredFrom$"
                        [maskSettings]="data.maskSettings"
                        [rightIcon]="icons.time"
                        [placeholder]="placeholder"
                        [isRightIconClickable]="true"
                        [validationErrorMessages]="validationErrorMessages"
                        [sizeControl]="sizeControl"
                        (touched)="markAsTouched()"
                        (rightIconClick)="openTimeCalendar('from')"
                    >
                    </bazis-input-default>
                </bazis-col>
                <bazis-col
                    [hidden]="!isInterval.value || !isInterval.value.length"
                    sizeSm="6"
                    sizeXs="12"
                    class="bazis-input-time"
                >
                    <bazis-input-default
                        #timeToCalendarToggler
                        [titleKey]="titleKeyTo"
                        formControlName="to"
                        [required$]="requiredTo$"
                        [maskSettings]="data.maskSettings"
                        [rightIcon]="icons.time"
                        [placeholder]="placeholder"
                        [isRightIconClickable]="true"
                        [validationErrorMessages]="validationErrorMessages"
                        [sizeControl]="sizeControl"
                        (touched)="markAsTouched()"
                        (rightIconClick)="openTimeCalendar('to')"
                    >
                    </bazis-input-default>
                </bazis-col>
            </bazis-row>
        </bazis-grid>
        <div
            *ngIf="
                !formGroup.controls.from?.errors &&
                !formGroup.controls.to?.errors &&
                formGroup.errors?.invalidIntervalTime
            "
            class="bazis-control__error"
        >
            <bazis-display-error errorKey="invalidIntervalTime"></bazis-display-error>
        </div>
        <div
            *ngIf="showIntervalCheckbox || showDayAndNightCheckbox"
            class="bazis-control__note"
        >
            <bazis-input-options
                *ngIf="showIntervalCheckbox"
                [formControl]="isInterval"
                [options]="isIntervalOptions"
                (touched)="markAsTouched()"
                captionEmpty=""
            ></bazis-input-options>

            <bazis-input-options
                *ngIf="showDayAndNightCheckbox"
                [formControl]="isDayAndNight"
                [options]="isDayAndNightOptions"
                (touched)="markAsTouched()"
                captionEmpty=""
            ></bazis-input-options>
        </div>
        <div
            *ngIf="showTimePicker === 'from'"
            clickOutside
            [excludeElement]="timeFromCalendarToggler.fieldEnd?.rightBtn"
            (clickOutside)="onClickOutsideTimepicker('from')"
        >
            <bazis-timepicker
                [value]="calendarValue ? calendarValue[0] : null"
                (valueChange)="setValueFromTimeCalendar($event, 'from')"
            ></bazis-timepicker>
        </div>

        <div
            *ngIf="showTimePicker === 'to'"
            clickOutside
            [excludeElement]="timeToCalendarToggler.fieldEnd?.rightBtn"
            (clickOutside)="onClickOutsideTimepicker('to')"
        >
            <bazis-timepicker
                [value]="calendarValue ? calendarValue[1] : null"
                (valueChange)="setValueFromTimeCalendar($event, 'to')"
            ></bazis-timepicker>
        </div>
    </div>
</ng-container>
